import React, { useEffect, useState } from 'react';
import { Box, Button, ScrollView, View } from 'native-base';

import { useAppSettings, useI18n, useSpringBigStore } from '@springbig/shared';
import MessageExtensionBox from './MessageExtensionBox';
import { useAppNavigate } from '~/pages';
import { useGeneralStyles, useMessagesStyles } from '~/shared/styles';

import type { Stashboard, NormalizedExtension } from '@springbig/shared';

export const SliderLinkCard = ({ data }: { data: Stashboard }) => {

    const { bottomNav } = useAppSettings();
    const { t } = useI18n();
    const { member, merchant } = useSpringBigStore();
    const { navigate, params } = useAppNavigate();
    const [canNavigateToCart, setCanNavigateToCart] = useState(false);
    const [canNavigateToShop, setCanNavigateToShop] = useState(false);
    const gStyle = useGeneralStyles();
    const { shop_now_button_background, shop_now_button_text } = useMessagesStyles();

    useEffect(() => {

        const canNavigateToCartTemp = bottomNav.find((value) => value?.toScreen === 'Cart');
        if (canNavigateToCartTemp && member?.merchant_website) {
            setCanNavigateToCart(true);
        }

        const canNavigateToShopTemp = bottomNav.find((value) => value?.toScreen === 'Shop');
        if (canNavigateToShopTemp && merchant?.dutchie_plus_enabled) {
            setCanNavigateToShop(true);
        }
    }, [bottomNav, merchant, member]);

    const sortExtensions = (stashboard: Stashboard) => {

        if (!stashboard) {
            return [];
        }

        const anyLinkExtensions = stashboard.any_link_extensions || [];
        const anyLinksNormalized = anyLinkExtensions.map((extension): NormalizedExtension => ({
            id: extension.id,
            thumbnail: extension.thumbnail?.url ?? null,
            title: extension.title,
            type: 'any_link',
            url: extension.url,
            wallet_type: null,
        }));

        const otherExtensions = stashboard.extensions?.filter(extension => extension.type !== 'any_link') || [];
        const otherExtensionsNormalized = otherExtensions.map((extension): NormalizedExtension => ({
            id: extension.id,
            thumbnail: extension?.reward_thumbnail ?? null,
            title: extension.title,
            type: extension.type,
            url: extension.url,
            wallet_type: extension.wallet_type ?? null,
        }));

        return [...anyLinksNormalized, ...otherExtensionsNormalized];
    };

    const extensions = sortExtensions(data);

    const navigateShopNow = () => {

        if (canNavigateToCart) {
            navigate(`w/${params.wallet_id}/cart`);
        }
        else if (canNavigateToShop) {
            navigate(`w/${params.wallet_id}/shop`);
        }
    };


    return (
        <Box
            w={'100%'}
        >
            {extensions.length > 0 ? (
                <View
                    mx={extensions.length === 1 ? 'auto' : ''}
                >
                    <ScrollView
                        my={6}
                        w={'100%'}
                        horizontal={true}
                        decelerationRate={0}
                        showsHorizontalScrollIndicator={true}
                    >
                        {extensions.map(extension => {

                            return (
                                <MessageExtensionBox
                                    key={`${extension.id}-${extension.type}`}
                                    stashboardKey={data._key}
                                    extension={extension}
                                />
                            );
                        })}
                    </ScrollView>
                </View>
            ) : ((canNavigateToCart || canNavigateToShop) && <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                <Button
                    style={{
                        width: '75%',
                        borderRadius: '999px',
                        fontSize: '1rem', 
                        padding: '10px 0',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                    backgroundColor={shop_now_button_background ?? gStyle.button_background}
                    _text={{ color: shop_now_button_text ?? gStyle.button_text }}
                    onPress={navigateShopNow}
                >
                    {t('messages.shop_now')}
                </Button>
            </div>)}
        </Box>
    );
};
